__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.54.22-0d27-amber-user-website-prod-hk-1879/assets/";